/*----- Core -----*/
import { takeLatest, put, call } from 'redux-saga/effects'

/*----- Components -----*/
import Notification from "../../../../components/commons/Notification"

/*----- Constants -----*/
import {
 	GET_PRODUCERS,
  GET_PRODUCERS_SUCCESS,
	GET_PRODUCERS_FAIL,
	LOAD_COMPLETED
} from './Constants'

import { PRODUCERS } from '../../../app/Constants'

/*----- Firestore -----*/
import { db } from '../../../../Firebase'

let data  = {}


function* shootGetProducers({payload}) {

	function* getProducers () {
		yield db.collection( PRODUCERS )
		.orderBy("lastname", "asc").get().then(snapshot => {
			snapshot.forEach(doc => {
				return data = {
					...data,
					[doc.id]: doc.data()
				}
			})
		})
	}

	try {
		yield call(getProducers)
		yield put({type: GET_PRODUCERS_SUCCESS, payload: data})
		yield put({type: LOAD_COMPLETED })
	} catch (error) {
		yield put({type: GET_PRODUCERS_FAIL, payload: error.message})
		Notification(error.message, 'error')
	}

}

export default function* getProducersWatcher() {
  yield takeLatest(GET_PRODUCERS, shootGetProducers)
}